import { render, staticRenderFns } from "./PavMatrix.vue?vue&type=template&id=5a184c0e&"
import script from "./PavMatrix.vue?vue&type=script&lang=js&"
export * from "./PavMatrix.vue?vue&type=script&lang=js&"
import style0 from "./PavMatrix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports